import React from "react";
import { getCustomerFullName } from "~/cores/customerCore";
import TurnrLink from "./TurnrLink";
import { getTurnrCustomerHref } from "~/cores/pageAccessCore";

export default function CustomerLink(props) {
    const { href, customer, children, ...rest } = props;
    return (
        <TurnrLink href={getTurnrCustomerHref({ customer })} {...rest}>
            {children || getCustomerFullName(customer)}
        </TurnrLink>
    );
}
